var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgQrSchweers(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 294.4 294.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer_1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M47.2,87.3h40V31.3H31.2v56h16ZM39.2,71.3v-32h40v40h-40v-8Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "63.2 71.3 71.2 71.3 71.2 63.3 71.2 55.3 71.2 47.3 63.2 47.3 55.2 47.3 47.2 47.3 47.2 55.3 47.2 63.3 47.2 71.3 55.2 71.3 63.2 71.3"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 55.2,
    y: 103.3,
    width: 8,
    height: 8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 55.2,
    y: 135.3,
    width: 8,
    height: 8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 55.2,
    y: 151.3,
    width: 8,
    height: 8
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "55.2 175.3 47.2 175.3 47.2 167.3 55.2 167.3 55.2 159.3 47.2 159.3 47.2 151.3 47.2 143.3 47.2 135.3 47.2 127.3 47.2 119.3 47.2 111.3 47.2 103.3 39.2 103.3 39.2 111.3 31.2 111.3 31.2 119.3 39.2 119.3 39.2 127.3 39.2 135.3 39.2 143.3 31.2 143.3 31.2 151.3 39.2 151.3 39.2 159.3 39.2 167.3 39.2 175.3 31.2 175.3 31.2 183.3 31.2 191.3 39.2 191.3 47.2 191.3 55.2 191.3 63.2 191.3 63.2 183.3 63.2 175.3 63.2 167.3 55.2 167.3 55.2 175.3"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "55.2 223.3 47.2 223.3 47.2 231.3 47.2 239.3 47.2 247.3 55.2 247.3 63.2 247.3 71.2 247.3 71.2 239.3 71.2 231.3 71.2 223.3 63.2 223.3 55.2 223.3"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 63.2,
    y: 143.3,
    width: 8,
    height: 8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 63.2,
    y: 191.3,
    width: 8,
    height: 8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.2,135.3h24v-8h-8v-8h8v8h8v-16h-8v-8h-8v8h-16v-8h16v-8h-32v8h8v16h-16v8h8v8h16ZM87.2,119.3v8h-8v-8h8Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.2,207.3H31.2v56h56v-56h-16ZM79.2,223.3v32h-40v-40h40v8Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "79.2 159.3 79.2 151.3 71.2 151.3 71.2 159.3 63.2 159.3 63.2 167.3 71.2 167.3 79.2 167.3 87.2 167.3 87.2 159.3 79.2 159.3"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 79.2,
    y: 175.3,
    width: 8,
    height: 8
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "87.2 143.3 79.2 143.3 79.2 151.3 87.2 151.3 87.2 159.3 95.2 159.3 95.2 151.3 103.2 151.3 103.2 143.3 95.2 143.3 87.2 143.3"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "103.2 175.3 103.2 167.3 103.2 159.3 95.2 159.3 95.2 167.3 87.2 167.3 87.2 175.3 95.2 175.3 103.2 175.3"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "103.2 191.3 111.2 191.3 119.2 191.3 119.2 183.3 119.2 175.3 119.2 167.3 111.2 167.3 111.2 175.3 111.2 183.3 103.2 183.3 95.2 183.3 87.2 183.3 87.2 191.3 79.2 191.3 79.2 199.3 87.2 199.3 95.2 199.3 95.2 191.3 103.2 191.3"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "111.2 31.3 103.2 31.3 103.2 39.3 95.2 39.3 95.2 47.3 103.2 47.3 111.2 47.3 111.2 39.3 111.2 31.3"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 103.2,
    y: 63.3,
    width: 8,
    height: 8
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "103.2 103.3 111.2 103.3 119.2 103.3 127.2 103.3 135.2 103.3 143.2 103.3 143.2 111.3 151.2 111.3 151.2 103.3 159.2 103.3 159.2 111.3 167.2 111.3 167.2 103.3 167.2 95.3 159.2 95.3 159.2 87.3 151.2 87.3 151.2 79.3 143.2 79.3 143.2 87.3 135.2 87.3 135.2 95.3 127.2 95.3 127.2 87.3 119.2 87.3 119.2 95.3 111.2 95.3 111.2 87.3 103.2 87.3 103.2 79.3 103.2 71.3 95.2 71.3 95.2 79.3 95.2 87.3 95.2 95.3 103.2 95.3 103.2 103.3"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 103.2,
    y: 135.3,
    width: 8,
    height: 8
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "111.2 87.3 119.2 87.3 119.2 79.3 119.2 71.3 111.2 71.3 111.2 79.3 111.2 87.3"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 111.2,
    y: 127.3,
    width: 8,
    height: 8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 111.2,
    y: 143.3,
    width: 8,
    height: 8
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "111.2 215.3 103.2 215.3 103.2 207.3 103.2 199.3 95.2 199.3 95.2 207.3 95.2 215.3 95.2 223.3 95.2 231.3 103.2 231.3 103.2 223.3 111.2 223.3 119.2 223.3 119.2 215.3 119.2 207.3 111.2 207.3 111.2 215.3"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 111.2,
    y: 239.3,
    width: 8,
    height: 8
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "119.2 167.3 127.2 167.3 127.2 175.3 135.2 175.3 135.2 167.3 135.2 159.3 127.2 159.3 127.2 151.3 119.2 151.3 119.2 159.3 119.2 167.3"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "119.2 199.3 119.2 207.3 127.2 207.3 135.2 207.3 135.2 199.3 127.2 199.3 119.2 199.3"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "127.2 247.3 119.2 247.3 119.2 255.3 111.2 255.3 111.2 263.3 119.2 263.3 127.2 263.3 135.2 263.3 135.2 255.3 127.2 255.3 127.2 247.3"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "127.2 79.3 127.2 87.3 135.2 87.3 135.2 79.3 143.2 79.3 143.2 71.3 135.2 71.3 135.2 63.3 127.2 63.3 127.2 55.3 135.2 55.3 135.2 47.3 143.2 47.3 143.2 55.3 151.2 55.3 151.2 47.3 151.2 39.3 151.2 31.3 143.2 31.3 143.2 39.3 135.2 39.3 127.2 39.3 127.2 31.3 119.2 31.3 119.2 39.3 119.2 47.3 111.2 47.3 111.2 55.3 119.2 55.3 119.2 63.3 119.2 71.3 127.2 71.3 127.2 79.3"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "127.2 127.3 127.2 135.3 135.2 135.3 135.2 127.3 135.2 119.3 127.2 119.3 127.2 127.3"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "127.2 239.3 127.2 247.3 135.2 247.3 135.2 255.3 143.2 255.3 143.2 247.3 143.2 239.3 143.2 231.3 135.2 231.3 135.2 239.3 127.2 239.3"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 135.2,
    y: 55.3,
    width: 8,
    height: 8
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "151.2 127.3 151.2 119.3 143.2 119.3 143.2 127.3 143.2 135.3 143.2 143.3 143.2 151.3 143.2 159.3 151.2 159.3 151.2 151.3 151.2 143.3 159.2 143.3 159.2 135.3 151.2 135.3 151.2 127.3"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "143.2 183.3 135.2 183.3 135.2 191.3 135.2 199.3 143.2 199.3 151.2 199.3 151.2 191.3 151.2 183.3 151.2 175.3 143.2 175.3 143.2 183.3"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 151.2,
    y: 55.3,
    width: 8,
    height: 8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 151.2,
    y: 111.3,
    width: 8,
    height: 8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 151.2,
    y: 247.3,
    width: 8,
    height: 8
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "159.2 79.3 159.2 87.3 167.2 87.3 167.2 79.3 167.2 71.3 175.2 71.3 183.2 71.3 183.2 63.3 175.2 63.3 167.2 63.3 159.2 63.3 159.2 71.3 159.2 79.3"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "159.2 167.3 159.2 159.3 151.2 159.3 151.2 167.3 151.2 175.3 159.2 175.3 167.2 175.3 167.2 167.3 159.2 167.3"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "167.2 183.3 167.2 191.3 175.2 191.3 175.2 183.3 175.2 175.3 167.2 175.3 167.2 183.3"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 175.2,
    y: 31.3,
    width: 8,
    height: 8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 175.2,
    y: 167.3,
    width: 8,
    height: 8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.2,207.3h-32v8h-16v16h8v-8h16v16h8v-16h16v-8h8v16h32v8h8v-8h8v-8h8v-8h-8v-24h-32v-8h-16v8h8v16h-8v-16h-8v16ZM199.2,199.3h24v24h-24v-24Z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 183.2,
    y: 71.3,
    width: 8,
    height: 8
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "183.2 87.3 183.2 79.3 175.2 79.3 175.2 87.3 167.2 87.3 167.2 95.3 175.2 95.3 175.2 103.3 175.2 111.3 167.2 111.3 167.2 119.3 159.2 119.3 159.2 127.3 159.2 135.3 167.2 135.3 167.2 127.3 175.2 127.3 175.2 135.3 183.2 135.3 191.2 135.3 191.2 127.3 191.2 119.3 183.2 119.3 183.2 111.3 183.2 103.3 191.2 103.3 199.2 103.3 199.2 95.3 199.2 87.3 199.2 79.3 191.2 79.3 191.2 87.3 183.2 87.3"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "199.2 63.3 199.2 55.3 199.2 47.3 191.2 47.3 191.2 39.3 183.2 39.3 183.2 47.3 175.2 47.3 175.2 39.3 167.2 39.3 167.2 47.3 167.2 55.3 175.2 55.3 183.2 55.3 183.2 63.3 191.2 63.3 199.2 63.3"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "215.2 135.3 207.2 135.3 207.2 143.3 199.2 143.3 191.2 143.3 191.2 151.3 183.2 151.3 175.2 151.3 175.2 143.3 167.2 143.3 167.2 151.3 159.2 151.3 159.2 159.3 167.2 159.3 167.2 167.3 175.2 167.3 175.2 159.3 183.2 159.3 183.2 167.3 191.2 167.3 199.2 167.3 199.2 175.3 207.2 175.3 215.2 175.3 223.2 175.3 231.2 175.3 239.2 175.3 239.2 167.3 231.2 167.3 223.2 167.3 215.2 167.3 207.2 167.3 207.2 159.3 207.2 151.3 215.2 151.3 215.2 143.3 215.2 135.3"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 207.2,
    y: 207.3,
    width: 8,
    height: 8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 215.2,
    y: 127.3,
    width: 8,
    height: 8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 215.2,
    y: 151.3,
    width: 8,
    height: 8
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "215.2 247.3 207.2 247.3 207.2 239.3 199.2 239.3 191.2 239.3 183.2 239.3 175.2 239.3 175.2 247.3 183.2 247.3 191.2 247.3 191.2 255.3 183.2 255.3 183.2 263.3 191.2 263.3 199.2 263.3 207.2 263.3 215.2 263.3 215.2 255.3 223.2 255.3 223.2 247.3 215.2 247.3"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "223.2 143.3 223.2 151.3 231.2 151.3 231.2 143.3 231.2 135.3 223.2 135.3 223.2 143.3"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "231.2 47.3 223.2 47.3 223.2 55.3 223.2 63.3 223.2 71.3 231.2 71.3 239.2 71.3 247.2 71.3 247.2 63.3 247.2 55.3 247.2 47.3 239.2 47.3 231.2 47.3"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 231.2,
    y: 151.3,
    width: 8,
    height: 8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 231.2,
    y: 183.3,
    width: 8,
    height: 8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 239.2,
    y: 135.3,
    width: 8,
    height: 8
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "255.2 95.3 247.2 95.3 247.2 103.3 239.2 103.3 231.2 103.3 223.2 103.3 223.2 95.3 215.2 95.3 207.2 95.3 207.2 103.3 199.2 103.3 199.2 111.3 191.2 111.3 191.2 119.3 199.2 119.3 199.2 127.3 207.2 127.3 207.2 119.3 207.2 111.3 215.2 111.3 223.2 111.3 231.2 111.3 231.2 119.3 231.2 127.3 231.2 135.3 239.2 135.3 239.2 127.3 239.2 119.3 247.2 119.3 247.2 111.3 255.2 111.3 255.2 119.3 247.2 119.3 247.2 127.3 255.2 127.3 255.2 135.3 255.2 143.3 255.2 151.3 263.2 151.3 263.2 143.3 263.2 135.3 263.2 127.3 263.2 119.3 263.2 111.3 263.2 103.3 255.2 103.3 255.2 95.3"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "247.2 223.3 247.2 231.3 239.2 231.3 239.2 239.3 231.2 239.3 231.2 247.3 231.2 255.3 223.2 255.3 223.2 263.3 231.2 263.3 239.2 263.3 239.2 255.3 239.2 247.3 247.2 247.3 247.2 255.3 247.2 263.3 255.2 263.3 255.2 255.3 263.2 255.3 263.2 247.3 263.2 239.3 255.2 239.3 255.2 231.3 263.2 231.3 263.2 223.3 255.2 223.3 255.2 215.3 247.2 215.3 247.2 223.3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.2,31.3h-48v56h56V31.3h-8ZM255.2,47.3v32h-40v-40h40v8Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "255.2 175.3 255.2 183.3 247.2 183.3 247.2 191.3 255.2 191.3 255.2 199.3 247.2 199.3 239.2 199.3 239.2 207.3 247.2 207.3 255.2 207.3 255.2 215.3 263.2 215.3 263.2 207.3 263.2 199.3 263.2 191.3 263.2 183.3 263.2 175.3 263.2 167.3 255.2 167.3 255.2 175.3"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "2 55.3 2 2 55.2 2 55.2 0 0 0 0 55.3 2 55.3"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "2 239.3 0 239.3 0 294.5 55.2 294.5 55.2 292.5 2 292.5 2 239.3"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "292.4 55.3 294.4 55.3 294.4 0 239.2 0 239.2 2 292.4 2 292.4 55.3"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "292.4 239.3 292.4 292.5 239.2 292.5 239.2 294.5 294.4 294.5 294.4 239.3 292.4 239.3"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQrSchweers);
export default __webpack_public_path__ + "static/media/qr_schweers.f6d26c098f2ac34908b46d7c4d8698fa.svg";
export { ForwardRef as ReactComponent };